import React, { useState, useEffect } from "react";

import moment from "moment-timezone";
import { cpfMask } from "../services/funcoesAuxiliares";
import InputMask from "react-input-mask";
const { criarCarteiras, apiUrl } = require("../services/requests");

const CriarCarteiraMobile = ({
  setModalVisivel,
  getCarteiras,
}) => {
  const date = new Date();
  const newDate = moment(date).locale("pt-br").format("YYYY-MM-DD HH:mm:ss");
  const dataValidade = new Date(date.getFullYear() + 1, 2, 31);
 
  const [nome, setNome] = useState("");
  const [instituicaoEnsino, setInstituicaoEnsino] = useState("");
  const [curso, setCurso] = useState("");
  const [imagemInicial] = useState(`${apiUrl}/images/0.png`);
  const [cpf, setCpf] = useState("");
  const [rg, setRg] = useState("");
  const [dataNascimento, setDataNascimento] = useState("");
  const [email, setEmail] = useState("");
  const [telefone, setTelefone] = useState("");
  const [dataEmissao] = useState(newDate);
  const [error, setError] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleCriarCarteira = async (event) => {
    event.preventDefault();

    if (isButtonDisabled || isSubmitting) return;
    setIsSubmitting(true);
    try {
      const endpoint = "/carteiras";

      await criarCarteiras(endpoint, {
        foto: imagemInicial,
        nome,
        instituicaoEnsino,
        curso,
        cpf,
        rg,
        dataNascimento,
        email,
        telefone,
        observacao: "",
      });
      handleClick(false);
      setError(false);
      alert("Carteira Criada Com Sucesso!");
      setNome("");
      setInstituicaoEnsino("");
      setCurso("");
      setCpf("");
      setRg("");
      setDataNascimento("");
      setEmail("");
      setTelefone("");
      getCarteiras("gestores", null, 1, 10);
    } catch (error) {
      if (error.request.status === 409) {
        setError(true);
      }
      console.log(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    const formData = [nome, instituicaoEnsino, curso, cpf, rg, dataNascimento];

    const isValidFormData = formData.every((value) => value !== "");
    setIsButtonDisabled(!isValidFormData);
  }, [nome, instituicaoEnsino, curso, cpf, rg, dataNascimento]);

  const handleClick = (value) => {
    setModalVisivel(value);
    getCarteiras("gestores", null, 1, 10)
  };

  return (
    <div className="w-full h-full flex flex-col bg-blue-600">
      <div className="flex-1 overflow-y-auto p-4">
        <div className="max-w-md mx-auto space-y-4">
          {/* Título */}
          <div className="text-center mb-6">
            <h2 className="text-2xl font-bold text-white mb-2">Criar Nova Carteira</h2>
            <p className="text-blue-100">Preencha os dados abaixo</p>
          </div>

          {/* Formulário */}
          <form className="space-y-4">
            <div>
              <input
                value={nome}
                id="nome"
                type="text"
                placeholder="NOME COMPLETO"
                onChange={(e) => setNome(e.target.value.toUpperCase())}
                className="w-full p-3 rounded-lg border-none font-medium text-gray-700 focus:ring-2 focus:ring-blue-300 focus:outline-none"
              />
            </div>

            <div>
              <input
                id="InstEnsino"
                placeholder="INSTITUIÇÃO DE ENSINO"
                value={instituicaoEnsino}
                type="text"
                onChange={(e) => setInstituicaoEnsino(e.target.value.toUpperCase())}
                className="w-full p-3 rounded-lg border-none font-medium text-gray-700 focus:ring-2 focus:ring-blue-300 focus:outline-none"
              />
            </div>

            <div>
              <input
                id="Curso"
                placeholder="CURSO"
                value={curso}
                type="text"
                onChange={(e) => setCurso(e.target.value.toUpperCase())}
                className="w-full p-3 rounded-lg border-none font-medium text-gray-700 focus:ring-2 focus:ring-blue-300 focus:outline-none"
              />
            </div>

            <div>
              <input
                id="cpf"
                placeholder="CPF"
                value={cpf}
                type="text"
                onChange={(e) => setCpf(cpfMask(e.target.value))}
                className="w-full p-3 rounded-lg border-none font-medium text-gray-700 focus:ring-2 focus:ring-blue-300 focus:outline-none"
              />
            </div>

            <div>
              <input
                id="RG"
                placeholder="RG"
                type="text"
                value={rg}
                onChange={(e) => setRg(e.target.value)}
                className="w-full p-3 rounded-lg border-none font-medium text-gray-700 focus:ring-2 focus:ring-blue-300 focus:outline-none"
              />
            </div>

            <div>
              <InputMask
                mask="99/99/9999"
                id="DataNascimento"
                placeholder="DATA DE NASCIMENTO"
                type="text"
                value={dataNascimento}
                onChange={(e) => setDataNascimento(e.target.value)}
                className="w-full p-3 rounded-lg border-none font-medium text-gray-700 focus:ring-2 focus:ring-blue-300 focus:outline-none"
              />
            </div>

            <div>
              <InputMask
                mask="(99) 9 9999-9999"
                id="telefone"
                placeholder="TELEFONE"
                type="tel"
                value={telefone}
                onChange={(e) => setTelefone(e.target.value)}
                className="w-full p-3 rounded-lg border-none font-medium text-gray-700 focus:ring-2 focus:ring-blue-300 focus:outline-none"
              />
            </div>

            {/* Mensagem de erro */}
            {error && (
              <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-lg">
                CPF já existe no sistema
              </div>
            )}

            {/* Botões */}
            <div className="flex gap-3 pt-4">
              <button
                type="submit"
                className="flex-1 py-3 bg-blue-900 hover:bg-blue-800 text-white font-medium rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                disabled={isButtonDisabled || isSubmitting}
                onClick={(event) => handleCriarCarteira(event)}
              >
                {isSubmitting ? "Criando..." : "Criar Carteira"}
              </button>
              <button 
                type="button"
                className="flex-1 py-3 bg-gray-600 hover:bg-gray-700 text-white font-medium rounded-lg transition-colors"
                onClick={() => handleClick(false)}
              >
                Cancelar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CriarCarteiraMobile;